import produce from 'immer'

import {
    BoardEvent,
    DragDropData,
    DragDropListsEvents,
    OnItemDeleteArgs,
    OptimisticLocalState,
    ServerEventStatus,
    State
} from '../../dtos'

export interface DeleteItemProps {
    onItemDeleteServer?: DragDropListsEvents['onItemDelete']
    optimisticOptions?: any
    setOptimisticState: React.Dispatch<
        React.SetStateAction<OptimisticLocalState>
    >
    setState: React.Dispatch<React.SetStateAction<State>>
    state: State
}

export const deleteItem = (props: DeleteItemProps) => {
    const {
        onItemDeleteServer,
        optimisticOptions,
        setOptimisticState,
        setState
    } = props

    const onItemDelete = async (args: OnItemDeleteArgs) => {
        // Delete local if optimistic, otherwise just wait for server's answer.
        if (optimisticOptions) {
            deleteItemLocal(args)
        }
        if (onItemDeleteServer) {
            setOptimisticState((state) => {
                const nextState = produce(state, (draftState) => {
                    draftState.event.push({
                        itemId: args.id,
                        type: BoardEvent.delete,
                        stateBeforeEvent: {
                            items: props.state.itemsBasicProps,
                            listOrder: props.state.listOrder,
                            lists: props.state.lists
                        },
                        serverEventStatus: ServerEventStatus.Loading
                    })
                })
                return nextState
            })

            try {
                const response = await onItemDeleteServer(args)
                setOptimisticState((state) => {
                    const nextState = produce(state, (draftState) => {
                        // @ts-ignore
                        draftState.event.find(
                            (e) => e.itemId === args?.id
                        ).serverEventStatus = ServerEventStatus.Success
                    })
                    return nextState
                })
            } catch {
                setOptimisticState((state) => {
                    const nextState = produce(state, (draftState) => {
                        // @ts-ignore
                        draftState.event.find(
                            (e) => e.itemId === args?.id
                        ).serverEventStatus = ServerEventStatus.Error
                    })
                    return nextState
                })
            }
        } else {
            console.log('Please provide a "onItemDelete" props')
        }
    }

    const deleteItemLocal = (args: OnItemDeleteArgs) => {
        const { listId, id } = args
        setState((state) => {
            const nextState = produce(state, (draftState) => {
                const indexToDelete = draftState.lists[
                    listId
                ].itemIds.findIndex((item) => item === id)
                draftState.lists[listId].itemIds.splice(indexToDelete, 1)
                delete draftState.items[id]
            })
            return nextState
        })
    }

    return onItemDelete
}
